import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import TooltipStyles from './styles';

/**
 * centralized wrapper around antd's tooltip for consistent tooltip styling
 */
const Tooltip = ({ title, placement = 'top', children, ...rest }) => (
  <>
    <TooltipStyles />
    <AntTooltip
      title={title}
      placement={placement}
      overlayClassName="styled-tooltip"
      mouseLeaveDelay={0}
      {...rest}
    >
      {children}
    </AntTooltip>
  </>
);

export default Tooltip;
